import React from "react";
import './index.css';
import ContestMenu from "./ContestMenu/ContestMenu";
import LayoutMain from "../../00LayoutMain/LayoutMain";
import SendQuestion from "../../00LayoutMain/TopMenu/SendQuestion/SendQuestion";
import QueryCurrentContestTag from "./QueryCurrentContestTag/QueryCurrentContestTag";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";

    function GatsbyContestGreatBattleNowSource (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        const MenuTop = [{Link : '',Name : props.PrerenderTexts['GreatBattleNow0080'] ? JSON.parse(props.PrerenderTexts['GreatBattleNow0080'])[props.lang] : '*Все конкурсы'},
            {Link : '/dailybitcoinnow/',Name : props.PrerenderTexts['GreatBattleNow0085'] ?  JSON.parse(props.PrerenderTexts['GreatBattleNow0085'])[props.lang] : '*Текущая торговля'},
            {Link : '/result/',Name : props.PrerenderTexts['GreatBattleNow0090'] ?  JSON.parse(props.PrerenderTexts['GreatBattleNow0090'])[props.lang] : '*Результаты прошлых'},
            {Link : '/prizes/',Name : props.PrerenderTexts['GreatBattleNow0095'] ?  JSON.parse(props.PrerenderTexts['GreatBattleNow0095'])[props.lang] : '*Получить приз'},
        ];
    return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang} Active={1}>
            <div className="TraderContestOut StandartGray">
                <div className="TraderContest">
                    <div className="StandartWhitePartTitle">
                        <div className="StandartWhitePartTitleText">
                            <TextSource ArrIndex= 'GreatBattleNow0010'>Великая битва - Весь список трейдеров</TextSource>
                        </div>
                        <SendQuestion lang={props.lang}/>
                    </div>
                    <ContestMenu lang={props.lang} Menu={MenuTop}/>
                </div>
                <QueryCurrentContestTag ContestName ={props.ContestName} lang={props.lang}/>
            </div>
        </LayoutMain>

    )}

export default GatsbyContestGreatBattleNowSource